module.exports = __webpack_public_path__ + "static/media/cl_3.e99f0d6c.jpg";